import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { FormattedMessage } from "react-intl";
import { Button, useDisclosure } from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import PendingPayoutsModal from "flows/PayoutV2/components/PendingPayoutsModal";

/**
 * PendingPayoutCancelButton
 * @param {object} props
 * @param {TxnVariant} props.transaction
 * @param {Function} props.onRefetch
 * @returns JSX.Element
 */
const PendingPayoutCancelButton = ({ transaction, onRefetch }) => {
  const queryClient = useQueryClient();
  const {
    isOpen: isCancelPendingPayoutOpen,
    onOpen: onOpenCancelPendingPayout,
    onClose: onCloseCancelPendingPayout,
  } = useDisclosure();

  const refetchAndClose = useCallback(() => {
    if (onRefetch) onRefetch();
    queryClient.clear(); // clear the query cache so we'll reload txn history items if user navigates back there
    if (isCancelPendingPayoutOpen) {
      onCloseCancelPendingPayout();
    }
  }, [onRefetch, isCancelPendingPayoutOpen, onCloseCancelPendingPayout, queryClient]);

  const isCancelablePayout = transaction.transaction_type === "payout" && transaction.transaction_status === "pending";

  if (!isCancelablePayout) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        colorScheme="gray"
        size="xs"
        rightIcon={<DeleteIcon />}
        onClick={onOpenCancelPendingPayout}
      >
        <FormattedMessage defaultMessage="Cancel" description="button copy" />
      </Button>
      <PendingPayoutsModal
        isOpen={isCancelPendingPayoutOpen}
        onClose={onCloseCancelPendingPayout}
        onUpdate={refetchAndClose}
        pendingPayouts={[transaction]}
      />
    </>
  );
};

export default PendingPayoutCancelButton;
